"use client";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import AuthView from "@components/auth/AuthView";
import CreateAccountInvitation from "@components/auth/auth-invitation/CreateAccountInvitation";
import LogInForm from "@components/auth/login/LogInForm";
import { Ribbon } from "@components/ui/ecco-club/ribbon";
import { CommonCMS } from "@lib/constants/contentful";
import {
    getPagePathByLocale,
    myAccountEccoClubPage,
    myAccountPage,
} from "@lib/constants/pagePaths";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { isMarketWithLoyalty } from "@lib/utils/loyalty";
import { Heading } from "@ecco/ui/heading";
import { Box } from "@ecco/ui/box";
import { Grid, GridItem } from "@ecco/ui/grid";
import { useRouter } from "@i18n/routing";
import { useLocale } from "next-intl";

export default function LoginClient() {
    const { siteSettings } = useGlobalContent();
    const forgotPassword = siteSettings.auth.forgotYourPassword;

    const { get: getMicrocopy } = useMicrocopy();
    const { push } = useRouter();
    const locale = useLocale();
    const onLogIn = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        isMarketWithLoyalty
            ? push(getPagePathByLocale(myAccountEccoClubPage, locale))
            : push(getPagePathByLocale(myAccountPage, locale));
    };

    return (
        <>
            <div hidden data-testid="logInPage" />
            <Heading
                as="h1"
                textTransform="capitalize"
                pb={[6, 12]}
                mt={[5, 8]}
                ml={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}
            >
                {getMicrocopy(CommonCMS.shared, CommonCMS.logInTitle)}
            </Heading>
            {isMarketWithLoyalty && (
                <Box px={[3, 4, 6]}>
                    <Box width="100%" height="9" marginTop="2" position="relative">
                        <Ribbon />
                    </Box>
                </Box>
            )}
            <Grid
                as="main"
                data-testid="logInPage"
                mb={8}
                gap={0}
                gridTemplateColumns={["100%", "100%", "100%", "2fr 1fr"]}
            >
                <GridItem>
                    <Box px={[3, 4, 6]} pr={[3, 4, 6, 0]}>
                        <AuthView titleKey="logInTitle">
                            <LogInForm
                                formId="logInForm"
                                onSuccess={onLogIn}
                                forgotPasswordText={forgotPassword}
                                isModalLogin={false}
                            />
                        </AuthView>
                    </Box>
                </GridItem>
                <GridItem>
                    <Box w="100%" px={[3, 4, 6]} pl={[3, 4, 6, 0.2]}>
                        <CreateAccountInvitation />
                    </Box>
                </GridItem>
            </Grid>
            {isMarketWithLoyalty && (
                <Box
                    css={{
                        width: "100% ",
                        height: "9",
                        position: "relative",
                        marginTop: "2",
                    }}
                >
                    <Ribbon />
                </Box>
            )}
        </>
    );
}
